module.exports = __webpack_public_path__ + "img/聚光-1.5d7fa56c.png";